import { render, staticRenderFns } from "./OidcCallback.vue?vue&type=template&id=3afd6b93&scoped=true&"
import script from "./OidcCallback.vue?vue&type=script&lang=js&"
export * from "./OidcCallback.vue?vue&type=script&lang=js&"
import style0 from "./OidcCallback.vue?vue&type=style&index=0&id=3afd6b93&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afd6b93",
  null
  
)

export default component.exports